import * as React from 'react'
import { t } from 'ttag'
import { formatThousands } from '../../common/helpers/translations'
import { StatisticsBar } from '../../components/StatisticsBar/StatisticsBar'
import { StatisticsCard } from '../../components/StatisticsBar/StatisticsCard/StatisticsCard'
import { CompanyId, CompanyStatistics, GetSpecificCompanyStatistics$Request, Lang } from '../../services/api.types'
import { Card } from '../../components/Card/Card'
import './FunFacts.scss'
import { isBurgerHidden } from '../RegisterUser/RegisterUser'
import { currentLang } from '../../i18nInit'

export interface IStatisticsProps {
  companyStatistics: CompanyStatistics
  selectedCompanyId: CompanyId | null
  companyId: CompanyId
}

export interface IStatisticsDispatchProps {
  getSpecificCompanyStatistics(payload: GetSpecificCompanyStatistics$Request): void
  setSelectedCompanyId(payload: CompanyId): void
}

export class FunFacts extends React.PureComponent<IStatisticsProps & IStatisticsDispatchProps> {
  static getStepsStats(totalSteps: number, roundsAroundTheWorld: number) {
    const y = formatThousands(totalSteps)
    let x: string | number = roundsAroundTheWorld
    if (roundsAroundTheWorld < 1) {
      x = Number(x * 100).toFixed(0)
    }
    const text =
      currentLang === Lang.EN
        ? `We're circling the earth... <b>${x}% (${y} steps)</b> of it is done`
        : t`We are circling the earth. <b>${x}% (${y} steps)</b> of it is done`
    if (roundsAroundTheWorld < 1) {
      return <StatisticsCard type="steps" text={text} />
    } else {
      return (
        <StatisticsCard
          type="steps"
          text={t`We have circled <b>${x} times (${y} steps)</b> around the earth together`}
        />
      )
    }
  }

  static getIntensiveMinutesStats(co2EmissionPrevented: number, totalMin: number) {
    const x = formatThousands(totalMin)
    const y = String(formatThousands(Math.round(co2EmissionPrevented)))
    const text =
      currentLang === Lang.EN
        ? `We've collected ${x} intensity mins. <b>${y} g of CO2</b> gases are released by a car in this time`
        : t`We have collected ${x} intensity min. <b>${y} g of CO2</b> gases are released by a car in this time`
    return <StatisticsCard text={text} type="intensiveMinutes" />
  }

  componentDidMount(): void {
    if (this.props.companyId) {
      this.props.getSpecificCompanyStatistics({ companyId: this.props.companyId })
    }
  }

  async UNSAFE_componentWillReceiveProps(nextProps: any) {
    // Clear isSubmitInProgress on error
    if (nextProps.companyId !== this.props.companyId) {
      this.props.getSpecificCompanyStatistics({ companyId: nextProps.companyId })
    }
  }

  getBurgerStats = (companyId: CompanyId, burgers: number): string => {
    const x = String(formatThousands(Math.round(burgers)))
    return companyId !== '0afa8503-baf3-4f7b-8e72-f133f716204e'
      ? currentLang === Lang.EN
        ? `We've spent <b>${x} Big Macs</b> in calories`
        : t`We have spent <b>${x} Big Mac's</b> worth of calories`
      : t`We have spent <b>${x} Whopper's</b> worth of calories`
  }

  render() {
    const {
      companyId,
      companyStatistics: {
        companyStepsStatistics: { totalSteps, roundsAroundTheWorld },
        companyIntensiveMinutesStatistics: { totalMin, co2EmissionPrevented },
        companyEnergyStatistics: { bigMacs },
      },
    } = this.props

    if (!companyId) {
      return (
        <Card>
          <h1 style={{ marginBottom: '1rem' }}>{t`Statistics`}</h1>
          Currently disabled for your company.
        </Card>
      )
    }

    const burgerStats = !isBurgerHidden(companyId) ? this.getBurgerStats(companyId, bigMacs) : undefined

    return (
      <StatisticsBar>
        {burgerStats ? <StatisticsCard text={burgerStats} type="calories" /> : ''}
        {FunFacts.getIntensiveMinutesStats(co2EmissionPrevented, totalMin)}
        {FunFacts.getStepsStats(totalSteps, roundsAroundTheWorld)}
      </StatisticsBar>
    )
  }
}
